module.exports = __webpack_public_path__ + "img/emoticon-nps-1-on.e086e4cb.svg";